import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import {
  Card,
  CardContent,
  CardHeader,
  Divider,
  Table,
  TableBody,
  Typography
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import useStyles from '../styles';
import InsuranceDetailDialog from './IsuranceDetailDialog';
import { createInsurance } from '../../../../store/actions/insuranceActions';
import InsuranceInfo from './InsuranceDetail';

const InsuranceDetail = ({ equipment }) => {
  const { classes } = useStyles();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, [setOpen]);

  const handleSubmit = useCallback(
    values => {
      if (!equipment.insurance) {
        dispatch(createInsurance(equipment.id, values));
        handleClose();
      }
    },
    [equipment, dispatch]
  );

  return (
    <Card variant="elevation">
      <CardHeader
        className={classes.header}
        title={
          <Typography className={classes.tableCell} component="h4" variant="h4">
            {t('EQUIPMENT_VIEW.EQUIPMENT_DETAIL.INSURANCE')}
          </Typography>
        }
      />
      <Divider className={classes.tableCell} />
      <CardContent style={{ padding: 0, marginBottom: '16px' }}>
        {equipment.insurance && (
          <Table>
            <TableBody>
              <InsuranceInfo equipment={equipment} />
            </TableBody>
          </Table>
        )}
        <InsuranceDetailDialog
          open={open}
          handleClose={handleClose}
          equipment={equipment}
          submit={handleSubmit}
        />
      </CardContent>
    </Card>
  );
};

InsuranceDetail.propTypes = {
  equipment: PropTypes.object
};

export default InsuranceDetail;
